<template>
  <div v-if="transactionActorDiagramData" style="width:100%;">
    <AdMermaid
      :key="key"
      :value="transactionActorDiagram"
    />
  </div>
</template>

<script>
import AdMermaid from '@/components/Utilities/AdMermaid'

export default {
  name: 'AdCreateSvg',

  props: {
    transaction: {
      type: Object,
      required: true,
      default: null
    },
    actors: {
      type: Array,
      required: false,
      default: null
    }
  },

  components: {
    AdMermaid
  },

  data () {
    return {
      key: 0
    }
  },

  computed: {
    /**
     * Params that have to be watched.
     */
    watchedParams () {
      return [
        this.$store.getters['app/projectLanguage']
      ]
    },

    transactionActorDiagramMeta () {
      return "%%{init: { 'securityLevel': 'loose', 'sequence': {'mirrorActors': false } } }%%\nsequenceDiagram\n"
    },
    transactionActorDiagramData () {
      const ts = []
      for (const tt of this.transaction.transaction) {
        // get all senders or type stationary actors of this transaction
        const acsnd =
          tt?.actors?.[0]?.actor?.filter(actor => ['sender', 'stationary'].find(a => a === actor.role)) || []
        // get all receivers of this transaction
        const acrcv = tt?.actors?.[0]?.actor?.filter(actor => actor.role === 'receiver') || []
        // get name of transaction
        const n = this.$filters.getMatchingTranslation({ value: tt?.name })
        for (const s of acsnd) {
          const sn = this.$filters.getMatchingTranslation({ value: this.actors.find(actor => actor.id === s.id)?.name })
          if (sn) {
            if (acrcv.length === 0) {
              ts.push('\n #10;' + sn + '->> #10;' + sn + ': ' + n)
            } else {
              for (const r of acrcv) {
                const rn = this.$filters.getMatchingTranslation({ value: this.actors.find(actor => actor.id === r.id)?.name })
                if (rn) {
                  ts.push('\n #10;' + sn + '->> #10;' + rn + ': ' + n)
                }
              }
            }
          }
        }
      }
      return ts.join(' ')
    },
    transactionActorDiagram () {
      return this.transactionActorDiagramMeta.concat(this.transactionActorDiagramData)
    }
  },

  watch: {
    /**
     * Watch watched params.
     */
    watchedParams: {
      immediate: true,
      deep: true,
      handler () {
        // Increment key.
        this.key++
      }
    }
  },

  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.actor {
    stroke: #ccccff;
    fill: #ececff !important;
    height: 55px !important;
}
text.actor {
    fill: #333;
    stroke: none;
    font-family: "Roboto" !important;
    font-size: 0.875rem !important;
    font-weight: 400 !important;
}

.actor-line {
    stroke: grey;
}

.messageLine0 {
    stroke-width: 1.0;
    stroke-dasharray: '2 2';
    marker-end: 'url(#arrowhead)';
    stroke: black;
}

.messageLine1 {
    stroke-width: 1.0;
    stroke-dasharray: '2 2';
    stroke: black;
}

#arrowhead {
    fill: black;
}

.messageText {
    stroke: none !important;
    font-family: "Roboto" !important;
    font-size: 14px !important;
}

.labelBox {
    stroke: #ccccff;
    fill: #ececff;
}

.labelText {
    fill: black;
    stroke: none;
    font-family: "Roboto" !important;
}

.loopText {
    fill: black;
    stroke: none;
    font-family: "Roboto" !important;
}

.loopLine {
    stroke-width: 2;
    stroke-dasharray: '2 2';
    marker-end: 'url(#arrowhead)';
    stroke: #ccccff;
}

.note {
    stroke: #decc93;
    fill: #fff5ad;
}

.noteText {
    fill: black;
    stroke: none;
    font-family: "Roboto" !important;
}
</style>
